// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2947":"11b01132","6429":"6532a47d","9361":"2c0daf62"}[chunkId] + ".chunk.css";
};